// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"1a9e88bd311d6cf23b97","293":"1da82f8ae1aa0281955c","518":"e9569cf94168c8826189","779":"287437a43ec06263032f"}[chunkId] + ".js";
};